import { TypedDocumentNode } from '@apollo/client';
import { useLazyQuery, useReactiveVar } from '@apollo/client/react';
import { Query } from 'graphql/generated/graphqlTypes';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { useEffect } from 'react';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { currentTenantVar } from 'state/vars';
import { BaseHookProps } from '../shared/types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_CURRENT_TENANT_TYPED: TypedDocumentNode<Pick<Query, 'getCurrentTenant'>> = GET_CURRENT_TENANT;

const useCurrentTenant = ({ handleFetchError }: BaseHookProps) => {
  const currentTenant = useReactiveVar(currentTenantVar);

  const [getCurrentTenant, { loading, data, error }] = useLazyQuery(GET_CURRENT_TENANT_TYPED);

  useEffect(() => {
    if (data) setCurrentTenantAction(data.getCurrentTenant);
  }, [data]);

  useEffect(() => {
    if (error) handleFetchError('Error while fetching tenant registration info');
  }, [error]);

  useEffect(() => {
    if (currentTenant === null) getCurrentTenant();
  }, [getCurrentTenant]);

  return {
    getCurrentTenant,
    currentTenant,
    loading
  };
};

export default useCurrentTenant;
